// extracted by mini-css-extract-plugin
module.exports = {"fab":"FabButton_fab__HBOGR","fabButton":"FabButton_fabButton__1r_Z6","icon":"FabButton_icon__1OI3E"};